import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigation-menu"
export default class extends Controller {
  static targets = ["menu", "toggle", "backdrop"]

  connect() {
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.close()
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
  }

  toggle(event) {
    event.preventDefault()

    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.menuTarget.setAttribute("aria-hidden", "false")
    this.showBackdrop()
    document.addEventListener("click", this.handleDocumentClick)
  }

  close(eventOrOptions = {}) {
    const restoreFocus = eventOrOptions?.restoreFocus === true

    this.menuTarget.classList.add("hidden")
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.menuTarget.setAttribute("aria-hidden", "true")
    this.hideBackdrop()
    document.removeEventListener("click", this.handleDocumentClick)

    if (restoreFocus) this.toggleTarget.focus()
  }

  closeWithKeyboard(event) {
    if (event.key === "Escape" && this.isOpen()) {
      this.close({ restoreFocus: true })
    }
  }

  handleDocumentClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  isOpen() {
    return !this.menuTarget.classList.contains("hidden")
  }

  showBackdrop() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden")
      this.backdropTarget.setAttribute("aria-hidden", "false")
    }
  }

  hideBackdrop() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
      this.backdropTarget.setAttribute("aria-hidden", "true")
    }
  }
}
